export default __webpack_public_path__ + "static/media/bombeo_solar_14.a0ecff97.png";